(function () {
  "use strict";

  function initMemberBestsellerSticky() {
    const sections = document.querySelectorAll(".section-memberbestseller");
    const topOffset = 0;

    function updateBannerState(section) {
      const banner = section.querySelector(".section-memberbestseller__banner");
      const stickyWrap = section.querySelector(
        ".section-memberbestseller__banner-sticky-wrap",
      );
      const products = section.querySelector(
        ".section-memberbestseller__products",
      );
      const grid = section.querySelector(".section-memberbestseller__grid");
      if (!banner || !stickyWrap || !products || !grid) return;

      const sectionRect = section.getBoundingClientRect();
      const productsRect = products.getBoundingClientRect();
      const viewportHeight = window.innerHeight;

      if (sectionRect.top > topOffset) {
        stickyWrap.style.position = "";
        stickyWrap.style.top = "";
        stickyWrap.style.left = "";
        stickyWrap.style.width = "";
        stickyWrap.style.maxHeight = "";
        stickyWrap.style.bottom = "";
        if (banner) banner.style.minHeight = "";
        section.classList.remove("is-banner-fixed", "is-banner-bottom");
      } else if (productsRect.bottom > viewportHeight) {
        section.classList.remove("is-banner-bottom");
        section.classList.add("is-banner-fixed");
        const rect = stickyWrap.getBoundingClientRect();
        stickyWrap.style.position = "fixed";
        stickyWrap.style.top = topOffset + "px";
        stickyWrap.style.left = rect.left + "px";
        stickyWrap.style.width = rect.width + "px";
        stickyWrap.style.maxHeight = viewportHeight - topOffset + "px";
        stickyWrap.style.bottom = "";
        if (banner) banner.style.minHeight = rect.height + "px";
      } else {
        section.classList.remove("is-banner-fixed");
        section.classList.add("is-banner-bottom");
        const bannerWidth = banner.getBoundingClientRect().width;
        stickyWrap.style.position = "absolute";
        stickyWrap.style.top = "";
        stickyWrap.style.left = "0";
        stickyWrap.style.width = bannerWidth + "px";
        stickyWrap.style.maxHeight = "";
        stickyWrap.style.bottom = "0";
        if (banner) banner.style.minHeight = "";
      }
    }

    function throttle(fn, ms) {
      let last = 0;
      return function () {
        const now = Date.now();
        if (now - last >= ms) {
          last = now;
          fn();
        }
      };
    }

    sections.forEach((section) => {
      const grid = section.querySelector(".section-memberbestseller__grid");
      if (grid && window.matchMedia("(min-width: 750px)").matches) {
        grid.style.position = "relative";
        updateBannerState(section);
      }
    });

    const throttledUpdate = throttle(function () {
      sections.forEach((section) => {
        if (window.matchMedia("(min-width: 750px)").matches) {
          updateBannerState(section);
        } else {
          const banner = section.querySelector(
            ".section-memberbestseller__banner",
          );
          const stickyWrap = section.querySelector(
            ".section-memberbestseller__banner-sticky-wrap",
          );
          if (stickyWrap) {
            stickyWrap.style.position = "";
            stickyWrap.style.top = "";
            stickyWrap.style.left = "";
            stickyWrap.style.width = "";
            stickyWrap.style.maxHeight = "";
            stickyWrap.style.bottom = "";
          }
          if (banner) banner.style.minHeight = "";
          section.classList.remove("is-banner-fixed", "is-banner-bottom");
        }
      });
    }, 16);

    window.addEventListener("scroll", throttledUpdate, { passive: true });
    window.addEventListener("resize", throttledUpdate);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initMemberBestsellerSticky);
  } else {
    initMemberBestsellerSticky();
  }

  if (typeof Shopify !== "undefined" && Shopify.designMode) {
    document.addEventListener(
      "shopify:section:load",
      initMemberBestsellerSticky,
    );
  }
})();
